import React from 'react'
import { Edit } from 'react-admin'
import WithDeleteModalToolbar from 'ui-shared/CustomToolbars/WithDeleteModalToolbar'
import OptionedProductSectionForm from 'ui-shared/Forms/OptionedProductSectionForm'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'

const PhysicalExperienceSectionEdit: React.FC = () => {
  return (
    <SectionWrapper title={'resources.physicalsections.editSection'}>
      <Edit>
        <OptionedProductSectionForm
          entity="physicals"
          toolbar={<WithDeleteModalToolbar />}
        />
      </Edit>
    </SectionWrapper>
  )
}

export default PhysicalExperienceSectionEdit
